import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'utcToLocal'
})
export class UtcToLocalPipe implements PipeTransform {
  transform(dateToTransform: Date, format: string): string {

    try {
      let dateString = dateToTransform.toString();

      // return if input date is null or undefined
      if (!dateString) {
        return null;
      }

      // append 'Z' to the date string to indicate UTC time if the timezone isn't already specified
      let dashMatchCount = (dateString.match(/-/g) || []).length;
      if (dateString.indexOf('Z') === -1 && dateString.indexOf('+') === -1 &&
          (dashMatchCount == 0 || dashMatchCount == 2)  // replaces dateString.indexOf('-') === -1
      ) {
        dateString += 'Z';
      }


      return new DatePipe('en-US').transform(dateString, format);
    }
    catch{
      return null;
    }
  };
}
